// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const ProcessedPullRequestStatusSchema = z.enum(['PROCESSING','COMPLETED','FAILED','PENDING'] as const);

export type ProcessedPullRequestStatusType = `${z.infer<typeof ProcessedPullRequestStatusSchema>}`

export default ProcessedPullRequestStatusSchema;
